import React from "react";
import { Banknote, Truck, Hammer, Home as HomeIcon, KeyRound, CheckCircle2 } from "lucide-react";

const MILESTONES = [
  { icon: <Banknote  size={16}/>, label: "Deposit received" },
  { icon: <Truck     size={16}/>, label: "Land cleared" },
  { icon: <Hammer    size={16}/>, label: "Foundations" },
  { icon: <HomeIcon  size={16}/>, label: "Walls & roof" },
  { icon: <KeyRound  size={16}/>, label: "Handover" },
  { icon: <CheckCircle2 size={16}/>, label: "Title registered" },
];

/**
 * Read-only visual of build progress vs payment.
 * `progressPct` (0..100) drives the fill; if undefined we derive it from
 * the user's payment schedule progress passed via `paidPct`.
 */
export default function MilestoneTimeline({ progressPct, paidPct = 0 }) {
  const p = Math.min(100, Math.max(0, Number(progressPct ?? paidPct) || 0));
  const activeIdx = Math.min(MILESTONES.length - 1, Math.floor((p / 100) * MILESTONES.length));

  return (
    <div className="mv-card p-6" data-testid="milestone-timeline">
      <div className="flex items-center justify-between mb-1">
        <div className="font-display text-[16px] mv-green-text">Your build milestones</div>
        <div className="text-[11.5px]" style={{ color: "var(--mv-muted)" }}>
          Payment released against progress · not upfront.
        </div>
      </div>
      <p className="text-[12.5px]" style={{ color: "var(--mv-muted)" }}>
        Independent trustees co-sign each release. You approve before the next payment leaves escrow.
      </p>

      {/* Progress bar */}
      <div className="mt-5 relative">
        <div className="h-2 rounded-full" style={{ background: "rgba(10,58,36,0.10)" }}/>
        <div
          className="h-2 rounded-full absolute top-0 left-0 transition-all"
          style={{ width: `${p}%`, background: "linear-gradient(90deg, #0A3A24, var(--mv-gold))" }}
          data-testid="milestone-progress-bar"
        />
      </div>

      <div className="mt-4 grid grid-cols-3 md:grid-cols-6 gap-2">
        {MILESTONES.map((m, i) => {
          const done = i <= activeIdx;
          return (
            <div key={m.label} className="text-center" data-testid={`milestone-step-${i}`}>
              <div className={`mx-auto w-8 h-8 rounded-full flex items-center justify-center border ${done ? "mv-green-bg text-white border-transparent" : "mv-hairline"}`}
                   style={done ? {} : { color: "var(--mv-muted)" }}>
                {m.icon}
              </div>
              <div className={`mt-1.5 text-[11px] leading-tight ${done ? "mv-green-text font-medium" : ""}`}
                   style={done ? {} : { color: "var(--mv-muted)" }}>
                {m.label}
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-4 text-[12px]" style={{ color: "var(--mv-muted)" }}>
        Current stage: <strong className="mv-green-text">{MILESTONES[activeIdx].label}</strong> ({p}% released)
      </div>
    </div>
  );
}
